import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './store/store';
import * as serviceWorkerRegistration from './utils/serviceWorkerRegistration';
// import '@fontsource/montserrat';

ReactDOM.render((
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
), document.getElementById('root'));

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('TruckSight PWA is ready for offline use');
  },
  onUpdate: () => {
    console.log('New version of TruckSight is available');
  }
});

// Initialize PWA install prompt
serviceWorkerRegistration.initializePWAPrompt();
